"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _images = require("../../images");

var _app = require("../../store/reducers/app");

var _app2 = require("../../store/selectors/app");

var _util = require("../../util");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Welcome = function Welcome(_ref) {
  var appEnv = _ref.appEnv;
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "jsx-2043729108" + " " + 'welcome-message-container'
  }, _react["default"].createElement("div", {
    className: "jsx-2043729108" + " " + 'welcome-message-images'
  }, _react["default"].createElement("div", {
    className: "jsx-2043729108" + " " + 'welcome-message-image-brand'
  }, _react["default"].createElement("img", {
    src: _images.imageGoDaddyGuides,
    alt: "GoDaddy Guides Text",
    className: "jsx-2043729108"
  })), _react["default"].createElement("div", {
    className: "jsx-2043729108" + " " + 'welcome-message-image-faces'
  }, _react["default"].createElement("img", {
    src: "".concat((0, _util.getCdnPath)(appEnv), "/images/godaddy-guides-faces.jpg"),
    alt: "GoDaddy Guides Human Faces",
    className: "jsx-2043729108"
  }))), _react["default"].createElement("div", {
    className: "jsx-2043729108" + " " + 'welcome-message-text'
  }, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "Support:HelpBot:Welcome:ChattingWith"
  }))), _react["default"].createElement(_style["default"], {
    id: "2043729108"
  }, ".welcome-message-container.jsx-2043729108{margin:24px 0;text-align:center;}.welcome-message-images.jsx-2043729108{margin-bottom:24px;}.welcome-message-image-brand.jsx-2043729108{margin-bottom:12px;text-align:center;}.welcome-message-image-brand.jsx-2043729108 img.jsx-2043729108{width:200px;}.welcome-message-image-faces.jsx-2043729108 img.jsx-2043729108{border:1px solid #E3E3E3;border-radius:50%;height:125px;width:125px;}.welcome-message-text.jsx-2043729108{font-size:14px;line-height:1.25;}"));
};

Welcome.propTypes = {
  appEnv: _app.appPropTypes.env
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appEnv: (0, _app2.getAppEnv)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Welcome);

exports["default"] = _default;